if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',
    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        document.body.classList.add('mobile-sticky-bar-enabled');
        this.init();
      }
      disconnectedCallback() {
        // Kein scroll listener mehr nötig
      }
      init() {
        this.calculateHeight();
        // Bar immer sichtbar machen
        this.classList.add('up');
        this.classList.remove('down');
        document.body.classList.add('mobile-sticky-bar-up');
        document.body.classList.remove('mobile-sticky-bar-down');
      }
      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }
      // onScrollHandler komplett entfernt - Bar bleibt immer sichtbar
    }
  );
}